import { BiBriefcaseAlt2, BiBulb, BiDownArrowCircle, BiLineChart, BiSlideshow } from 'react-icons/bi';

export const RECENT_ACTIVITY = [
  {
    icon: <BiLineChart />,
    title: 'Google Project',
    subTitle: 'Completed in 3 Hours',
  },
  {
    icon: <BiBriefcaseAlt2 />,
    title: 'Business Logo Create',
    subTitle: 'Completed in 5 Hours',
  },
  {
    icon: <BiBulb />,
    title: 'Business Research',
    subTitle: 'Due in 1 hour',
  },
  {
    icon: <BiSlideshow />,
    title: 'Recruitment in IT',
    subTitle: 'Completed in 2 Hours',
  },
  {
    icon: <BiDownArrowCircle />,
    title: 'Submit Riverfront Project',
    subTitle: 'Completed in 2 Days',
  },
];
